// components/MyMap.js
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

const position = [33.6844, 73.0479]; 

export default function Map() {
  return (
    <MapContainer center={position} zoom={13} style={{ height: "370px", width: "100%", borderRadius:"20px" }}>
      <TileLayer
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <Marker position={position}>
        <Popup>
          Islamabad City 🚀
        </Popup>
      </Marker>
    </MapContainer>
  );
}
